import type { Component } from '@wix/thunderbolt-becky-types'
import { createCssCompNode } from '../cssCompNode'
import { toCompVariants } from '../../utils/toCompVariants'
import type { FeatureRefs } from '../cssFeatures.types'
import { isRefArray } from '../../utils/variantsUtils'

export const cursorVariants = createCssCompNode('cursor', 'cursorVariants', {
	getDependencies: (component: Component, refs: FeatureRefs<'cursor'>) =>
		component.cursorQuery ? refs.cursorQuery(component.cursorQuery) : undefined,
	toViewItem: (__, cursorRefArray) => (isRefArray(cursorRefArray) ? toCompVariants(cursorRefArray.values) : null),
})
